import i18n from "../i18n";
export const WITHOUT_VAT_KEY = "WITHOUT_VAT";
import * as mathjs from "mathjs";
export default class VatUtils {
  static getVatLabel(vat: number | null | undefined) {
    if (vat === undefined || vat === null) {
      return i18n.t("without_vat");
    }

    return vat;
  }

  static convertVatsToSelectOptions(vats: Array<null | number>) {
    return vats.map((x) => {
      if (x === null) {
        return {
          label: i18n.t("without_vat"),
          value: WITHOUT_VAT_KEY,
        };
      }
      return {
        label: x,
        value: x,
      };
    });
  }

  static convertVatValue(vat: number | null | undefined): typeof WITHOUT_VAT_KEY | number {
    if (vat === null || vat === undefined) {
      return WITHOUT_VAT_KEY;
    }

    return vat;
  }

  static convertVatValues(vats: Array<number | null>): Array<typeof WITHOUT_VAT_KEY | number> {
    return vats.map((x) => this.convertVatValue(x));
  }

  static convertVatValueToUpdate(vat: typeof WITHOUT_VAT_KEY | number): number | null {
    if (vat === WITHOUT_VAT_KEY) {
      return null;
    }

    return vat;
  }

  static convertVatValuesToUpdate(vats: Array<typeof WITHOUT_VAT_KEY | number>): Array<number | null> {
    return vats.map((x) => this.convertVatValueToUpdate(x));
  }

  static getVatValue(vat: number | null | undefined): number {
    if (vat === undefined || vat === null) {
      return 0;
    }

    return vat;
  }

  static hasVat(vat: number | null | undefined): boolean {
    return vat !== undefined && vat !== null && vat !== 0;
  }

  static calculateTotalSumWithVat({
    count,
    bid,
    vat,
    vatIncluded,
  }: {
    count: number;
    bid: number;
    vat: null | number;
    vatIncluded: boolean;
  }) {
    const vatCount = vat === null ? 0 : vat;
    const cost = count * bid;
    return mathjs.round(vatIncluded ? cost : cost + (cost * vatCount) / 100, 2);
  }
}
